<div class="container">
  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <div class="container">
    <mat-expansion-panel [hideToggle]="true" [expanded]="!loaded">
      <mat-expansion-panel-header>
        <mat-panel-title>Filtros</mat-panel-title>
        <mat-panel-description></mat-panel-description>
      </mat-expansion-panel-header>

      <form [formGroup]="form">
        <div fxLayout="row" fxLayout.lt-lg="column">
          <mat-form-field
            floatLabel="always"
            appearance="outline"
            fxFlex="50"
            fxFlex.lt-md="100"
          >
            <mat-label>Cliente</mat-label>
            <input
              #company
              matInput
              [matAutocomplete]="company"
              formControlName="company"
              [(ngModel)]="selectedCompany"
              (keyup)="filterOptionsCompany($event.target.value)"
              (blur)="checkSelectedCompany($event.target.value)"
              [readonly]="optionsCompany.length === 1"
            />
            <mat-autocomplete
              #company="matAutocomplete"
              autoActiveFirstOption
              [displayWith]="displayCompany"
              (optionSelected)="changeCompany()"
            >
              <mat-option
                *ngFor="let item of filteredOptionsCompany"
                [value]="item"
              >
                {{ item.description }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="outline"
            fxFlex="33"
            fxFlex.lt-md="100"
          >
            <mat-label>Regional</mat-label>
            <input
              #regional
              matInput
              [matAutocomplete]="regional"
              formControlName="regional"
              [(ngModel)]="selectedRegional"
              (keyup)="filterOptionsRegional($event.target.value)"
              (blur)="checkSelectedRegional($event.target.value)"
              [readonly]="optionsRegional.length === 1"
            />
            <mat-autocomplete
              #regional="matAutocomplete"
              autoActiveFirstOption
              [displayWith]="displayRegional"
              (optionSelected)="loadServiceLocalOptions()"
            >
              <mat-option
                *ngFor="let item of filteredOptionsRegional"
                [value]="item"
              >
                {{ item.description }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="outline"
            fxFlex="33"
            fxFlex.lt-md="100"
          >
            <mat-label>Localidade</mat-label>
            <input
              #serviceLocal
              matInput
              [matAutocomplete]="serviceLocal"
              formControlName="serviceLocal"
              [(ngModel)]="selectedServiceLocal"
              (keyup)="filterOptionsServiceLocal($event.target.value)"
              (blur)="checkSelectedServiceLocal($event.target.value)"
              [readonly]="optionsServiceLocal.length === 1"
            />
            <mat-autocomplete
              #serviceLocal="matAutocomplete"
              autoActiveFirstOption
              [displayWith]="displayServiceLocal"
              (optionSelected)="changeServiceLocal()"
            >
              <mat-option
                *ngFor="let item of filteredOptionsServiceLocal"
                [value]="item"
              >
                {{ item.description }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.lt-lg="column">
          <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-lg="100">
            <mat-label>BEM</mat-label>
            <mat-input-container floatPlaceholder="auto">
              <input
                matInput
                formControlName="bem"
                type="text"
                placeholder="BEM"
              />
            </mat-input-container>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-lg="100">
            <mat-label>Plaqueta</mat-label>
            <mat-input-container floatPlaceholder="auto">
              <input
                matInput
                formControlName="plaqueta"
                type="text"
                placeholder="Plaqueta"
              />
            </mat-input-container>
          </mat-form-field>
        </div>

        <div
          fxLayout="row"
          fxLayout.lt-lg="column"
          fxLayoutAlign="space-between center"
          class="btn__register__container"
        >
          <button
            mat-raised-button
            type="submit"
            color="primary"
            fxFlex="30"
            fxFlex.lt-lg="100"
            (click)="loadTabData()"
          >
            Consultar
          </button>
        </div>
      </form>
    </mat-expansion-panel>

    <mat-tab-group
      #tabGroup
      animationDuration="1000ms"
      (selectedTabChange)="loadTabData()"
    >
      <mat-tab label="Relatório de Inventário">
        <!--   <mat-expansion-panel [hideToggle]="true" [expanded]="!loaded">
          <mat-expansion-panel-header>
            <mat-panel-title>Filtros</mat-panel-title>
            <mat-panel-description></mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="form">
            <div fxLayout="row" fxLayout.lt-lg="column">
              <mat-form-field
                appearance="outline"
                fxFlex="50"
                fxFlex.lt-lg="100"
              >
                <mat-label>Cliente</mat-label>
                <mat-select
                  id="company"
                  name="company"
                  formControlName="company"
                  change
                >
                  <mat-option value="T">TODOS</mat-option>
                  <mat-option
                    *ngFor="let company of companyOptions"
                    [value]="company"
                  >
                    {{ company?.description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field
                appearance="outline"
                fxFlex="33"
                fxFlex.lt-lg="100"
              >
                <mat-label>Regional</mat-label>
                <mat-select
                  id="regional"
                  name="regional"
                  formControlName="regional"
                >
                  <mat-option value="T">TODAS</mat-option>
                  <mat-option
                    *ngFor="let regional of regionalOptions"
                    [value]="regional.id"
                  >
                    {{ regional?.description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field
                appearance="outline"
                fxFlex="33"
                fxFlex.lt-lg="100"
              >
                <mat-label>Localidade</mat-label>
                <mat-select
                  id="serviceLocal"
                  name="serviceLocal"
                  formControlName="serviceLocal"
                >
                  <mat-option value="T">TODAS</mat-option>
                  <mat-option
                    *ngFor="let serviceLocal of serviceLocalOptions"
                    [value]="serviceLocal.id"
                  >
                    {{ serviceLocal?.description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayout.lt-lg="column">
              <mat-form-field
                appearance="outline"
                fxFlex="50"
                fxFlex.lt-lg="100"
              >
                <mat-label>BEM</mat-label>
                <mat-input-container floatPlaceholder="auto">
                  <input
                    matInput
                    formControlName="bem"
                    type="text"
                    placeholder="BEM"
                  />
                </mat-input-container>
              </mat-form-field>

              <mat-form-field
                appearance="outline"
                fxFlex="50"
                fxFlex.lt-lg="100"
              >
                <mat-label>Plaqueta</mat-label>
                <mat-input-container floatPlaceholder="auto">
                  <input
                    matInput
                    formControlName="plaqueta"
                    type="text"
                    placeholder="Plaqueta"
                  />
                </mat-input-container>
              </mat-form-field>
            </div>

            <div
              fxLayout="row"
              fxLayout.lt-lg="column"
              fxLayoutAlign="space-between center"
              class="btn__register__container"
            >
              <button
                mat-raised-button
                type="submit"
                color="primary"
                fxFlex="30"
                fxFlex.lt-lg="100"
                (click)="loadTabData()"
              >
                Consultar
              </button>
            </div>
          </form>
        </mat-expansion-panel>
 -->
        <div
          fxFlex="100"
          fxLayout="row"
          fxLayout.lt-lg="column"
          fxLayoutAlign="space-between center"
          fxLayoutAlign.lt-lg="center"
        >
          <mat-card fxFlex="30" fxFlex.lt-lg="100">
            <mat-card-title-group>
              <mat-card-title>Total de Etas</mat-card-title>
            </mat-card-title-group>
            <mat-card-content class="indicator-content">
              {{ invetoryIndicators.totalEtas }}
            </mat-card-content>
          </mat-card>

          <mat-card fxFlex="30" fxFlex.lt-lg="100">
            <mat-card-title-group>
              <mat-card-title>Bens Inventariados</mat-card-title>
            </mat-card-title-group>
            <mat-card-content class="indicator-content">
              {{ invetoryIndicators.totalInventoried }}
            </mat-card-content>
          </mat-card>
        </div>

        <mat-card class="card-list" *ngIf="loaded">
          <mat-card-content>
            <div fxLayout="column" fxFlex="100" class="inventory">
              <div fxLayout="row" fxFlex="100" class="inventory__header">
                <div fxFlex="15">ETA</div>
                <div fxFlex="5">DATA</div>
                <div fxFlex="8">TÉCNICO</div>
                <div fxFlex="10">BEM</div>
                <div fxFlex="5">FOTO</div>
                <div fxFlex="8">TIPO</div>
                <div fxFlex="10">DETALHE</div>
                <div fxFlex="22">ITEM</div>
                <div fxFlex="5">QTD</div>
                <div fxFlex="8">OBSERVAÇÃO</div>
              </div>

              <div
                fxLayout="row"
                fxFlex="100"
                *ngIf="!groupedInventory.length && loaded"
              >
                Nenhum Registro Localizado
              </div>

              <div
                fxLayout="column"
                fxFlex="100"
                *ngFor="
                  let inventory of groupedInventory
                    | paginate
                      : {
                          itemsPerPage: itemsPerPage,
                          currentPage: currentPage,
                          id: 'invetory'
                        }
                "
              >
                <div
                  fxLayout="row"
                  fxFlex="100"
                  [ngClass]="{
                    inventory__bem: inventory.tipo === 1,
                    inventory__item: inventory.tipo !== 1
                  }"
                >
                  <div fxFlex="15">{{ inventory?.eta }}</div>
                  <div fxFlex="5">
                    {{ inventory?.data_ref | date : "shortDate" }}
                  </div>
                  <div fxFlex="8">{{ inventory?.tecnico }}</div>
                  <div fxFlex="10">{{ inventory?.bem }}</div>
                  <div fxFlex="5">
                    <mat-ico
                      class="icons"
                      (click)="openImage(inventory?.e_fotobem)"
                      >image</mat-ico
                    >
                  </div>
                  <div fxFlex="8">
                    {{ inventory?.tipo | invetoryType }}
                  </div>
                  <div fxFlex="10">{{ inventory?.tipo_detalhe }}</div>
                  <div fxFlex="22">{{ inventory?.descricao }}</div>
                  <div fxFlex="5">{{ inventory?.e_qtd }}</div>
                  <div fxFlex="8">{{ inventory?.e_obs }}</div>
                </div>
              </div>

              <pagination-controls
                *ngIf="groupedInventory.length"
                id="invetory"
                previousLabel="Anterior"
                nextLabel="Próximo"
                class="my-pagination"
                (pageChange)="currentPage = $event"
              ></pagination-controls>
              <div
                fxLayout="row"
                fxLayout.lt-lg="column"
                fxLayoutAlign="space-between center"
                class="btn__register__container"
              >
                <button
                  mat-raised-button
                  type="submit"
                  color="primary"
                  (click)="exportExcel()"
                  fxFlex="30"
                  fxFlex.lt-lg="100"
                  [disabled]="!groupedInventory.length"
                >
                  Baixar Planilha
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>

      <mat-tab label="ETA">
        <div
          fxFlex="100"
          fxLayout="row"
          fxLayout.lt-lg="column"
          fxLayoutAlign="space-between center"
          fxLayoutAlign.lt-lg="center"
        >
          <mat-card fxFlex="30" fxFlex.lt-lg="100">
            <mat-card-title-group>
              <mat-card-title>Total de Etas</mat-card-title>
            </mat-card-title-group>
            <mat-card-content class="indicator-content">
              {{ etaIndicators.totalEtas }}
            </mat-card-content>
          </mat-card>

          <mat-card fxFlex="30" fxFlex.lt-lg="100">
            <mat-card-title-group>
              <mat-card-title>Etas Inventariadas</mat-card-title>
            </mat-card-title-group>
            <mat-card-content class="indicator-content">
              {{ etaIndicators.totalInventoried }}
            </mat-card-content>
          </mat-card>
        </div>

        <mat-card class="card-list" *ngIf="loaded">
          <mat-card-content>
            <div fxLayout="column" fxFlex="100" class="inventory">
              <div fxLayout="row" fxFlex="100" class="inventory__header">
                <div fxFlex="25">CLIENTE</div>
                <div fxFlex="25">REGIONAL</div>
                <div fxFlex="25">ETA</div>
                <div fxFlex="5">ÚLTIMO INVENTÁRIO</div>
                <div fxFlex="20">TÉCNICO</div>
              </div>

              <div
                fxLayout="row"
                fxFlex="100"
                *ngIf="!etaInventoried.length && loaded"
              >
                Nenhum Registro Localizado
              </div>

              <div
                fxLayout="column"
                fxFlex="100"
                *ngFor="
                  let eta of etaInventoried
                    | paginate
                      : {
                          itemsPerPage: itemsPerPageEta,
                          currentPage: currentPageEta,
                          id: 'eta'
                        }
                "
              >
                <div fxLayout="row" fxFlex="100" class="inventory__item">
                  <div fxFlex="25">{{ eta?.empresa }}</div>
                  <div fxFlex="25">{{ eta?.regional }}</div>
                  <div fxFlex="25">{{ eta?.eta }}</div>
                  <div fxFlex="5">
                    {{ eta?.data_ref | date : "shortDate" }}
                  </div>
                  <div fxFlex="20">{{ eta?.tecnico }}</div>
                </div>
              </div>

              <pagination-controls
                *ngIf="etaInventoried.length"
                id="eta"
                previousLabel="Anterior"
                nextLabel="Próximo"
                class="my-pagination"
                (pageChange)="currentPageEta = $event"
              ></pagination-controls>

              <div
                fxLayout="row"
                fxLayout.lt-lg="column"
                fxLayoutAlign="space-between center"
                class="btn__register__container"
              >
                <button
                  mat-raised-button
                  type="submit"
                  color="primary"
                  (click)="exportEtaExcel()"
                  [disabled]="!etaInventoried.length"
                >
                  Baixar Planilha
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
